<div>
    <p-toast [life]="3000" [baseZIndex]="50000" [preventOpenDuplicates]="true"></p-toast>
    <router-outlet></router-outlet>
</div>